import {
    IDHFSection,
    IDHFControlDefinition,
    IDHFSectionOptions,
    DocumentSectionType,
} from "../../../common/businesslogic/index";
import { IBaseControlOptions } from "../../../common/UI/Controls/BaseControl";
import { IDocFieldHandler } from "../../../common/businesslogic/FieldHandlers/Document/IDocFieldHandler";
import { BaseDHFSection } from "./BaseDHFSection";
import { GenericFieldHandler } from "../../../common/businesslogic/FieldHandlers/GenericFieldHandler";
import { SectionDescriptions } from "../../../common/businesslogic/FieldHandlers/Document/SectionDescriptions";
import { GenericDocFieldHandler } from "../../../common/businesslogic/FieldHandlers/Document/GenericDocFieldHandler";

export { Hidden };

class Hidden extends BaseDHFSection<IDHFSectionOptions> implements IDHFSection {
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    renderControl(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions) {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        ctrl.control.hidden(ctrlParameter);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    showSpecificSettings(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions, custom: JQuery) {}
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async saveSpecificSettingsAsync(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions, custom: JQuery) {
        return false;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async verifyContentAsync(ctrl: IDHFControlDefinition) {}
}
